export enum CommunicationType {
  ALL = 'all',
  CALL = 'call',
  EMAIL = 'email',
  TEXT = 'text',
}

export enum CommunicationTiming {
  ALL = 'all',
  PRE = 'pre',
  DURING = 'during',
  POST = 'post',
}

export interface CommunicationGuidanceUiElements {
  [key: string]: string[];
}
